const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyMjcxLCJjb25ncmVzc0lkIjoxNDg0LCJkYXRlIjoiMjAyNC0wMy0wNVQwOToxMjozMy4xMzhaIiwiaWF0IjoxNzA5NjI5OTUzfQ.uKky8KtAgo0S-GrjjxyrzdBMO7GhryqmIKmtrI6qX-Y';
const PLANNER_API_URL = 'https://ueg2024.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyMjcyLCJjb25ncmVzc0lkIjoxNDg0LCJkYXRlIjoiMjAyNC0wMy0wNVQwOToxMjo0NS43NjhaIiwiaWF0IjoxNzA5NjI5OTY1fQ.N7rIGVLCPDw3q3FSViFSvjmxim-IfCJHt1HoXJjEQkI';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const CONGRESS_ID = 1484;
const SYSTEM = 'program_industry_2024';
const SUBMISSION_API_URL = 'https://ueg2024.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

export {
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  PLANNER_API_URL,
  CONGRESS_ID,
  SYSTEM,
  SUBMISSION_API_URL,
}
